import clamp from "lodash/clamp"
import React, { useState } from "react"
import styled from "styled-components"
import { theme } from "~/theme"
import {
  NumberInput as BaseNumberInput,
  type NumberInputProps as BaseNumberInputProps,
} from "~/ur-react-components"
import { useTranslate } from "~/ur-react-hooks"

const StyledNumberInput = styled(BaseNumberInput)``

interface InputProps extends BaseNumberInputProps {}
export const NumberInput = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      height = "48px",
      borderColor = theme.colors.gray70,
      borderRadius = "4px",
      ...props
    },
    ref,
  ) => {
    return (
      <StyledNumberInput
        ref={ref}
        height={height}
        borderColor={borderColor}
        borderRadius={borderRadius}
        {...props}
      />
    )
  },
)

const StyledNumberInputWithStep = styled(NumberInput)`
  .--input-input {
    border-left: none;
    border-right: none;
  }

  .--input-icon-left,
  .--input-icon-right {
    height: auto;
  }
`

export const NumberInputWithStep = React.forwardRef<
  HTMLInputElement,
  InputProps
>(
  (
    {
      value,
      height = "48px",

      max: maxValue = Number.POSITIVE_INFINITY,
      min: minValue = Number.NEGATIVE_INFINITY,
      borderRadius = "4px",
      onChange,
      ...props
    },
    ref,
  ) => {
    const [error, setError] = useState<string | undefined>(undefined)
    const translations = useTranslate({
      maxValueReached: "errors.max-value-reached",
      minValueReached: "errors.min-value-reached",
    })

    function handleOnStepClick(
      increment: boolean,

      step = 1,
    ) {
      return () => {
        const finalValue = clamp(
          value + (increment ? step : -step),
          minValue,
          maxValue,
        )
        const errorMessage =
          value >= maxValue
            ? translations.maxValueReached
            : value <= minValue
              ? translations.minValueReached
              : undefined
        setError(errorMessage)
        onChange(finalValue)
      }
    }

    return (
      <StyledNumberInputWithStep
        ref={ref}
        value={value}
        error={error}
        errorTimeout={3000}
        onErrorTimeout={() => setError(undefined)}
        height={height}
        textAlign="center"
        iconLeftProps={{
          icon: "minus",
          boxCursor: "pointer",
          onClick: handleOnStepClick(false),
        }}
        iconRightProps={{
          icon: "plus",
          boxCursor: "pointer",
          onClick: handleOnStepClick(true),
        }}
        onChange={onChange}
        {...props}
      />
    )
  },
)
